import React from 'react';
import { redirectToHome } from '../utils';
import { trans } from '../localization/language';

export default class Success extends React.Component {
	componentDidMount() {
		const url = sessionStorage.getItem('cpn_redirect_url');
		if (url) {
			sessionStorage.removeItem("cpn_redirect_url")
			window.location.href = url;
		} else {
			redirectToHome({url: this.props.redirectTo});
		}
	}

	render() {
		return (
			<div className="content">
				<div className="content-item content-item--ipage">
					<div className="content-item__title">
						{this.props.title}
					</div>
					<div className="content-item__main">
						<div className="content-item--ipage__main">
							<div className="content__result content__result--successful">
								<div className="content__result-icon content__result-icon--successful"></div>
								<div className="content__result-txt">
									{this.props.message}
								</div>
							</div>
							<div className="content__sendinfo">
								{trans('redirect_home_msg')} <span id="J-success-cdele"></span>s
							</div>
							<div className="content__submit-wrap">
								<a href="/" className="content__submit">{trans('back_home')}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./app/components/Success.js